// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Badge,
  Box,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import { METHOD_CARDS } from './constants';

const getCardStyle = (isSelected) => ({
  border: isSelected ? '2px solid #0972d3' : '2px solid #d5dbdb',
  borderRadius: '12px',
  cursor: 'pointer',
  backgroundColor: isSelected ? '#f2f8fd' : '#ffffff',
  transition: 'all 0.15s ease-in-out',
  padding: '20px',
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
});

const MethodSelector = ({ selectedMethod, onSelect }) => {
  return (
    <SpaceBetween size="m">
      <Box variant="p" color="text-body-secondary" textAlign="center">
        Select how you want to onboard your AWS account to ResourceLens
      </Box>
      <div
        style={{
          display: 'flex',
          gap: '20px',
          maxWidth: '1100px',
          margin: '0 auto',
          alignItems: 'stretch',
        }}
      >
        {Object.entries(METHOD_CARDS).map(([key, card]) => (
          <div
            key={key}
            style={getCardStyle(selectedMethod === key)}
            onClick={() => onSelect(key)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(key);
              }
            }}
            aria-pressed={selectedMethod === key}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <Box variant="h3" padding={{ bottom: 'xxs' }}>
                {card.title}
              </Box>
              <SpaceBetween direction="horizontal" size="xs">
                {card.badge && <Badge color="green">{card.badge}</Badge>}
                {card.recommended && <Badge color="blue">Recommended</Badge>}
              </SpaceBetween>
            </div>
            <Box variant="p" color="text-body-secondary" padding={{ bottom: 's' }}>
              {card.description}
            </Box>
            <TextContent>
              <ul>
                {card.characteristics.map((item) => (
                  <li key={item}>
                    {item === 'Coming soon: Drift detection' ? (
                      <em>{item}</em>
                    ) : (
                      item
                    )}
                  </li>
                ))}
              </ul>
            </TextContent>
          </div>
        ))}
      </div>
    </SpaceBetween>
  );
};

export default MethodSelector;
